import { IColumnProps } from 'taltech-styleguide';
import { createBuilder, createColumnProps } from './_builder';
import { columnDefaultProps } from './_shared';
import { colCreatedDate, colId, colModifiedDate } from './entity';
import { colNumber } from './course-number';
import { colFirstAndLastName, colFirstName, colLastName, colName } from './name';
import { colValue, colValueDefault } from './value-default';
import { colCourseLogo } from './course-logo';
import { colStartDate, colEndDate } from './dates';
import { colInitials } from './initials';
import { colRole } from './role';
import { colDescription } from './description';
import { colEmail } from './email';
import { colCreationType, colEnum, colSourceId, colSourceType } from './enums';
import { colLecturer } from './lecturers';
import { colMin, colMax } from './parameters';
import { colState } from './state';
import { colSubmissions } from './submission-date';
import { colTitle } from './title';
import { colAssignmentReSubmission } from './assignmentReSubmission';
import { colFileExtension } from './extension';

const create = (props: Partial<IColumnProps>, order: number) => {
  return createBuilder(props, order);
};

export const cols = {
  id: create(colId, 0),
  initials: create(colInitials, 100),
  courseLogo: create(colCourseLogo, 101),
  number: create(colNumber, 110),
  name: create(colName, 110),
  colFirstAndLastName: create(colFirstAndLastName, 110),
  fileExtension: create(colFileExtension, 111),
  firstName: create(colFirstName, 120),
  lastName: create(colLastName, 130),
  role: create(colRole, 140),
  email: create(colEmail, 150),
  title: create(colTitle, 200),
  description: create(colDescription, 210),
  type: create(colEnum, 220),
  creationType: create(
    createColumnProps(colCreationType, {
      dataField: 'creationType',
      text: 'Creation',
    }),
    221
  ),
  class: create(
    createColumnProps(colEnum, { dataField: 'class', text: 'Class' }),
    230
  ),
  state: create(
    createColumnProps(colEnum, { dataField: 'state', name: 'State' }),
    240
  ),
  stateTag: create(colState, 250),

  lecturer: create(colLecturer, 300),
  submissions: create(colSubmissions, 400),

  valueDefault: create(colValueDefault, 500),
  value: create(colValue, 501),
  min: create(colMin, 510),
  max: create(colMax, 520),

  assignmentReSubmission: create(colAssignmentReSubmission, 900),
  startDate: create(colStartDate, 900),
  endDate: create(colEndDate, 910),
  sourceType: create(colSourceType, 920),
  sourceId: create(colSourceId, 930),
  createdDate: create(colCreatedDate, 999),
  modifiedDate: create(colModifiedDate, 999),
  build: (props: Partial<IColumnProps>) =>
    createColumnProps(columnDefaultProps, props),
  custom: create({ sort: false }, 800),
};

export type ColumnType = [keyof typeof cols];
